<template>
  <div class='d-flex'>
    <ModalTabVideos
      :instructionalVideos="instructionalVideos"
      :timer="timer"
      ref="modalTabVideosSideBar"
    >
    </ModalTabVideos>

    <b-modal
      id='modalCheckPendingInvoice'
      size='lg'
      title='Fatura pendente'
      header-bg-variant='danger'
      header-text-variant='light'
      ref='modalCheckPendingInvoice'
      @hide="hideModalCheckPendingInvoice()"
    >
      <p>
        Gostaríamos de informá-lo que há uma fatura pendente em seu plano.
        Por favor, verifique seu e-mail ou <a :href='secure_url' target='_blank'>clique aqui</a> para visualizar a
        fatura e efetuar o pagamento o quanto antes.
      </p>
      <p>
        É importante ressaltar que o não pagamento da fatura poderá resultar em suspensão dos serviços.
      </p>
      <p>
        Em caso de dúvidas ou para mais informações, por favor entre em contato com nossa equipe de suporte ao cliente.
      </p>
      <template #modal-footer='{ ok, cancel, hide }'>
        <b-button class='px-5' size='sm' variant='success' @click='ok()'>
          <strong>OK</strong>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id='modalAccessCollaboratorRemaining'
      size='lg'
      title='Acesso a subordinados'
      header-bg-variant='info'
      header-text-variant='light'
      ref='modalAccessCollaboratorRemaining'
      @hide='hideModalAccessCollaboratorRemaining()'
    >
      <p>
        Gostaríamos de informá-lo que ainda resta {{remainingAmount}} {{remainingAmount > 1 ? 'acessos' : 'acesso'}} a subordinados.
      </p>

      <template #modal-footer='{ ok, cancel, hide }'>
        <b-button class='px-5' size='sm' variant='success' @click="goToRouter('/colaboradores')">
          <span>Ver meus colaboradores</span>
        </b-button>
      </template>
    </b-modal>

    <dialog-confirmation
      description='Você está prestes a ativar o período de testes do HO Fácil Web. Ao clicar no botão de confirmar você terá acesso completo à plataforma durante os próximos 7 dias contados a partir da sua confirmação.'
      :is-open='openDialog'
      @confirmed='handleUsePlanTrial'
      @close='hideModalDialogPlanTrial()'
    />

    <b-modal
      ref='show-log'
      size='xl'
      scrollable
      hide-footer
      title='Atualização'
      header-bg-variant="info"
      header-text-variant="light"
      :no-close-on-esc="closeModalUpdateNew"
      :no-close-on-backdrop="closeModalUpdateNew"
      :hide-header-close="closeModalUpdateNew"
      @show="showModalUpdateNew()"
      @hide="hideModalUpdateNew()"
    >
      <section class="modal-font-family">
        <p  v-if="closeModalUpdateNew" class='text-right'>Você poderá fechar esse modal em <strong>{{ time }} segundos</strong></p>
        <add-update-new :readOnly='true' :log='updateNew' />
      </section>
    </b-modal>

    <Renew-modal if='openSurvey.login' v-if='renew' :is-open='renewable' @close='renewable = false' />

    <div class='content'>
      <div>
        <SideMenu @collapse='collapseSideMenu' />
      </div>

      <div>
        <main
          :class='{ menuCollapsed: menuCollapsed }'
          v-if='itIsStillNecessaryToAcceptTermsOrPolicyPrivacy()'
        >
          <div class='mt-4 ml-2'>
            <h4>Termos de uso atualizado</h4>
            <p>Os Termos de Uso e Política de Privacidade - do sistema foram atualizados:</p>
            <section class='mb-3' v-if='acceptTermsUse()'>
              <Terms
                title='CONTRATO DE TERMOS DE USO'
                textLink='Tenha acesso aos termos de uso da Ho Fácil Web'
                :link='term.termsOfUseUrl'
              />

              <p class='mt-2'>
                <b-form-checkbox v-model='confirmTermsOfUseUrl'>Eu estou ciente e de acordo com os termos de uso.</b-form-checkbox>
              </p>

              <b-overlay
                :show='loadingTermsOfUse'
                rounded
                opacity='0.6'
                spinner-small
                style='width: fit-content'
                spinner-variant='primary'
                class=''
              >
                <b-button
                  variant='success'
                  @click='confirmAcceptedTermsOfUse()'
                  class='mb-2  '
                  :disabled='!confirmTermsOfUseUrl'
                >
                  Aceitar
                </b-button>
              </b-overlay>
            </section>

            <hr/>

            <section v-if='acceptPolicyPrivacy()'>
              <Terms
                title='CONTRATO DE POLÍTICA DE PRIVACIDADE'
                textLink='Tenha acesso a política de privacidade da Ho Fácil Web'
                :link='term.privacyPolicyUrl'
              />
              <p class='mt-2'>
                <b-form-checkbox v-model='confirmPrivacyPolicyUrl'>Eu estou ciente e de acordo com a política de privacidade.</b-form-checkbox>
              </p>
              <b-overlay
                :show='loadingPrivacyPolicy'
                rounded
                opacity='0.6'
                spinner-small
                style='width: fit-content'
                spinner-variant='primary'
                class=''
              >
                <b-button
                  variant='success'
                  @click='confirmTerms'
                  class='mb-2  '
                  :disabled='!confirmPrivacyPolicyUrl'
                >
                  Aceitar
                </b-button>
              </b-overlay>
            </section>
          </div>
        </main>

        <main
          style='height: 100%'
          :class='{ menuCollapsed: menuCollapsed }'
          class='mt-2'
          v-else-if='checkProfileIsFilled(user) || isFillingProfile()'
        >
          <div class='content_top'>
            <div>
              <div>
                <breadcrumb />
              </div>

              <div class='d-flex mt-3 align-content-end flex-wrap'>
                <buttons />
              </div>
            </div>

            <div class='mobile d-flex'>
              <section class='mr-2'>
                <base-button
                  v-if='userEligibleUserFreeTrial'
                  style='width: 210px'
                  class='mb-1'
                  pulse
                  sucess
                  @click='showModalDialogPlanTrial()'
                >
                  Clique aqui para ativar <br />seu teste grátis
                </base-button>

                <base-button
                  pulse
                  style='font-size: 15px; width: 180px; height: 37.6px'
                  @click='showModalRenewPlan()'
                  v-if='getRenewalPlan && (getRenewalPlan.withinTheStandardPeriod || getRenewalPlan.priceIncreaseAlert)'
                >
                  Renove seu plano!
                </base-button>
                <mvp-announcement class='mt-2' />
              </section>

              <div
                v-if='limitationOfAgentsAdded'
                style='min-width: 235px; width: 235px'
                class='mb-2'
              >
                <limitation-of-agents-added />
              </div>

              <event v-if='eventActive' :event='eventActive'/>

              <div v-else>
                <notification @readFullNotification='readFullNotification' />
              </div>
            </div>
          </div>
        </main>

        <main :class='{ menuCollapsed: menuCollapsed }' v-else>
          <div id='page-title'>
            <h1>Perfil pendente</h1>
          </div>
          Complete seu perfil
          <router-link :to="{ name: 'Profile' }">aqui</router-link>
        </main>

        <main
          :class='{ menuCollapsed: menuCollapsed }'
          v-if='(checkProfileIsFilled(user) || isFillingProfile()) && !itIsStillNecessaryToAcceptTermsOrPolicyPrivacy()'
        >
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/layouts/components/SideMenu'
import Breadcrumb from '@/layouts/components/Breadcrumb'
import Notification from '@/layouts/components/Notification'
import AddUpdateNew from '@/components/UpdateNew/AddUpdateNew'
import Event from '@/components/Events/Event'
import MvpAnnouncement from '@/components/Mvp/MvpAnnouncement'
import LimitationOfAgentsAdded from '@/components/LimitationOfAgentsAdded/LimitationOfAgentsAdded'
import RenewModal from '@/layouts/components/RenewModal'
import DialogConfirmation from '@/components/DialogConfirmation.vue'
import Terms from '@/components/Terms'
import Buttons from '../components/LegalSearch/components/Buttons'
import { profileIsFilled } from '../utils/checkProfileIsFilled'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import terms from '@/components/Terms.vue'
import eventBus from '../utils/eventBus'
import ModalTabVideos from '@/components/InstructionalVideos/components/ModalTabVideos.vue'

export default {
  components: {
    ModalTabVideos,
    SideMenu,
    Terms,
    AddUpdateNew,
    Breadcrumb,
    Notification,
    Event,
    MvpAnnouncement,
    RenewModal,
    DialogConfirmation,
    Buttons,
    LimitationOfAgentsAdded
  },
  data() {
    return {
      instructionalVideos: [],
      timer: false,
      secure_url: undefined,
      plan: undefined,
      renewable: false,
      confirm: false,
      confirmTermsOfUseUrl: false,
      confirmPrivacyPolicyUrl: false,
      updateNew: null,
      menuCollapsed: true,
      loadingPrivacyPolicy: false,
      loadingTermsOfUse: false,
      pagetitle: this.$route.meta.pagetitle,
      subtitle: this.$route.meta.subtitle,
      pagetitleicon: this.$route.meta.pagetitleicon,
      openDialog: false,
      remainingAmount: 0,
      closeModalUpdateNew: true,
      interval: null,
      timeout: null,
      start: null,
      end: null,
    }
  },
  computed: {
    terms() {
      return terms
    },
    user() {
      return this.$store.getters['user/current']
    },
    checkPendingInvoice() {
      return this.$store.getters['user/checkPendingInvoice']
    },
    checkAmountOfRemainingSubordinateAccess() {
      return this.$store.getters['user/checkAmountOfRemainingSubordinateAccess']
    },
    showRenewPlan() {
      return this.$store.getters['user/showRenewPlan']
    },
    userEligibleUserFreeTrial() {
      return this.$store.getters['user/userEligibleUserFreeTrial']
    },
    eventActive() {
      return this.$store.getters['event/eventActive']
    },
    title() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return (this.pagetitle = this.$route.meta.pagetitle)
    },
    pageIcon() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return (this.pagetitleicon = this.$route.meta.pagetitleicon)
    },
    renew() {
      return !!this.getRenewalPlan
    },
    ...mapGetters('userPlans', {
      limitationOfAgentsAdded: 'limitationOfAgentsAdded'
    }),
    ...mapGetters('plan', {
      signedPlan: 'getSignedPlan',
      getRenewalPlan: 'getRenewalPlan',
    }),
    term() {
      return this.$store.getters['term/term']
    },
    time(){
      return this.start ? moment(this.start).format('mm:ss') : ''
    }
  },

  async mounted() {
    try {
      await this.updateModalCheckPendingInvoiceBeingShown(true)
      new Promise(resolve => setTimeout(resolve, 100))
      await this.updateModalCheckPendingInvoiceBeingShown(false)

      await this.handleUserEligibleUserFreeTrial()
      await this.checkIfTheUserHasSignedPlan()
      this.plan = this.signedPlan

      if (this.checkPendingInvoice) {
        const { secure_url } = await this.handlePlanInvoice(this.user)
        if (secure_url) {
          this.secure_url = secure_url
          this.$refs.modalCheckPendingInvoice.show()
          await this.updateModalCheckPendingInvoiceBeingShown(true)
        }
        await this.getUserViewedOneMinuteNewUpdate()
        await this.setCheckPendingInvoice(false)

        const instructionalVideos = await this.handleGetByUser(this.user.id)
        if (instructionalVideos && instructionalVideos.length > 0) {
          this.instructionalVideos = instructionalVideos
          this.timer = true
          setTimeout(() => {
            this.$refs.modalTabVideosSideBar.init()
          },100)
        }
      }

      const { plan } = this.user
      if (this.checkAmountOfRemainingSubordinateAccess && plan && plan.status && plan.status === 'paid'){
        const { remainingAmount } = await this.handleAmountAccessCollaboratorRemaining(plan._id)
        this.remainingAmount = remainingAmount
        if(this.remainingAmount && this.remainingAmount > 0) {
          this.$refs.modalAccessCollaboratorRemaining.show()
          await this.updateModalAccessCollaboratorRemainingBeingShown(true)
        }
        await this.setCheckAmountOfRemainingSubordinateAccess(false)
      }

      await this.checkRenewalDiscount({userId: this.user.id, showRenewPlan: this.showRenewPlan })
      if (this.showRenewPlan && this.renew) {
        await this.showModalRenewPlan()
      }
      await this.handleGet()
    } catch (err) {
      console.log(err)
    }
  },
  async beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  },
  methods: {
    ...mapActions('event', {
      handlGetEventActive: 'handlGetEventActive'
    }),
    ...mapActions('user', {
      setCheckPendingInvoice: 'setCheckPendingInvoice',
      handleUserEligibleUserFreeTrial: 'handleUserEligibleUserFreeTrial',
      setCheckAmountOfRemainingSubordinateAccess: 'setCheckAmountOfRemainingSubordinateAccess',
    }),
    ...mapActions('plan', {
      checkIfTheUserHasSignedPlan: 'checkIfTheUserHasSignedPlan',
      checkIfFreeTrialSubscription: 'checkIfFreeTrialSubscription',
      checkRenewalDiscount: 'checkRenewalDiscount',
    }),
    ...mapActions('userPlans', {
      handlePlanInvoice: 'handlePlanInvoice'
    }),
    ...mapActions('term', {
      handleGet: 'handleGet'
    }),
    ...mapActions('acessCollaborator', {
      handleAmountAccessCollaboratorRemaining: 'handleAmountAccessCollaboratorRemaining'
    }),
    ...mapActions('updateNews', {
      handleGetUserViewedOneMinuteNewUpdate: 'handleGetUserViewedOneMinuteNewUpdate',
      handleAddUserViewedOneMinuteNewUpdate: 'handleAddUserViewedOneMinuteNewUpdate',
    }),
    ...mapActions('instructionalVideo', {
      handleGetByUser: 'handleGetByUser',
    }),
    ...mapActions('access', {
      updateModalCheckPendingInvoiceBeingShown: 'updateModalCheckPendingInvoiceBeingShown',
      updateModalAccessCollaboratorRemainingBeingShown: 'updateModalAccessCollaboratorRemainingBeingShown',
      updateModalPlanTrialBeingShown: 'updateModalPlanTrialBeingShown',
      updateModalUpdateNewBeingShown: 'updateModalUpdateNewBeingShown',
      updateModalRenewBeingShown: 'updateModalRenewBeingShown',
    }),
    async hideModalCheckPendingInvoice(){
      await this.updateModalCheckPendingInvoiceBeingShown(false)
    },

    async hideModalAccessCollaboratorRemaining(){
      await this.updateModalAccessCollaboratorRemainingBeingShown(false)
    },

    async hideModalDialogPlanTrial(){
      this.openDialog = false
      await this.updateModalPlanTrialBeingShown(false)
    },
    async showModalDialogPlanTrial(){
      this.openDialog = true
      await this.updateModalPlanTrialBeingShown(true)
    },

    callGlobalCustomEvent(event, body) {
      eventBus.$emit(event, body)
    },

    goToRouter(router) {
      this.$refs.modalAccessCollaboratorRemaining.hide()
      this.$router.push({ path: router})
    },

    async showModalRenewPlan() {
      this.$bvModal.show('renew-modal')
    },

    async handleUsePlanTrial() {
      const response = (await this.$api.post('checkout/trial')).data
      let message = ''
      let variant = ''

      if (response.message) {
        message = response.message
        variant = 'success'
      }
      if (response.errors) {
        message = response.errors
        variant = 'danger'
      }

      this.openDialog = false
      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
      const sessionId = localStorage.getItem("sessionId");
      const user = (await this.$api.get(`users/${sessionId}`)).data
      await this.$store.dispatch('user/updateUser', user)
      await this.handleUserEligibleUserFreeTrial()
      await this.checkIfTheUserHasSignedPlan()
      await this.checkIfFreeTrialSubscription()
    },

    readFullNotification(notificationId) {
      this.updateNew = notificationId
      this.$refs['show-log'].show()
      this.closeModalUpdateNew = false
    },

    async getUserViewedOneMinuteNewUpdate() {
      try {
        const { data } = await this.handleGetUserViewedOneMinuteNewUpdate(this.user.id)
        const { showModal, newUpdate } = data
        this.updateNew = newUpdate._id
        if(showModal){
          setTimeout(() => {
            this.$refs['show-log'].show()
          }, 100)
        }
      } catch (e) {
        console.log(e)
      }
    },

    async showModalUpdateNew() {
      this.closeModalUpdateNew = true
      clearInterval(this.interval);
      clearTimeout(this.timeout);
      this.startTimer()

      this.timeout = setTimeout(async () => {
        if (this.closeModalUpdateNew) {
          await this.handleAddUserViewedOneMinuteNewUpdate({ newUpdateId: this.updateNew, userId: this.user.id })
        }
        this.closeModalUpdateNew = false
      }, 10000)
      await this.updateModalUpdateNewBeingShown(true)
    },

    async hideModalUpdateNew() {
      clearInterval(this.interval);
      clearTimeout(this.timeout);
      await this.updateModalUpdateNewBeingShown(false)
    },

    startTimer() {
      this.start = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours(), 0, 10);
      this.end = moment(this.start).add(-10, 'seconds').toDate();

      this.interval = setInterval( () => {
        if(moment(this.start).isAfter(moment(this.end))){
          this.start = moment(this.start).add(-1, 'seconds').toDate()
        }
      }, 1000);
    },

    closeModal() {
      this.$emit('close')
    },

    itIsStillNecessaryToAcceptTermsOrPolicyPrivacy() {
      return this.acceptTermsUse() || this.acceptPolicyPrivacy();
    },

    acceptTermsUse() {
      return !this.user.termsConfirmation;
    },

    acceptPolicyPrivacy() {
      return !this.user.privacyPolicyConfirmation;
    },

    isFillingProfile() {
      return this.$router.currentRoute.name === 'Profile'
    },

    checkProfileIsFilled(user) {
      return profileIsFilled(user)
    },

    hasFullProfile() {
      const attrs = [
        'name',
        'rg',
        'gender',
        'birthday',
        'cpf',
        'comercialPhone',
        'phone',
        'cep',
        'address',
        'number',
        'neighborhood',
        'city',
        'state'
      ]
      for (let attr in attrs) {
        if (!this.user.profile[attrs[attr]]) return false
      }
      return true
    },

    async confirmTerms() {
      this.loadingPrivacyPolicy = true;
      await this.$api.put(`users/${this.user.id}`, {
        privacyPolicyConfirmation: true,
        privacyPolicyUrl: this.term.privacyPolicyUrl,
        privacyPolicyDate: this.term.privacyPolicyDate,
        privacyPolicyName: this.term.privacyPolicyName,
      })
      const sessionId = localStorage.getItem("sessionId");
      const user = (await this.$api.get(`users/${sessionId}`)).data
      await this.$store.dispatch('user/updateUser', user)
      this.loadingPrivacyPolicy = false;
    },

    async confirmAcceptedTermsOfUse() {
      this.loadingTermsOfUse = true;
      await this.$api.put(`users/${this.user.id}`, {
        termsConfirmation: true,
        termsOfUseUrl: this.term.termsOfUseUrl,
        termsOfUseDate: this.term.termsOfUseDate,
        termsOfUseName: this.term.termsOfUseName,
      })
      const sessionId = localStorage.getItem("sessionId");
      const user = (await this.$api.get(`users/${sessionId}`)).data
      await this.$store.dispatch('user/updateUser', user)
      this.loadingTermsOfUse = false;
    },

    collapseSideMenu() {
      this.menuCollapsed = !this.menuCollapsed
    },

    changePageTitle(pageTitle) {
      return (this.pagetitle = pageTitle)
    },

    signout() {
      this.$api
        .get('auth/signout')
        .then(() => {
          this.$store.dispatch('user/updateUser', undefined)
          this.$router.push({ name: 'Signin' })
        })
        .catch((err) => {
          console.log(err)
        })
    },

    redefinePwd() {
      this.$router.push({ name: 'RedefinePwd' })
    }
  }
}
</script>

<style lang='scss' scoped>
div.page-title {
  padding-top: 2rem;
  width: 97%;
  margin: 0 auto;
}

div.page-title h1 {
  color: #04a7f3;
  font-size: 30px;
  font-weight: 700;
  margin: 0;
}

div.page-title p {
  color: #04a7f3;
  font-size: 15px;
  font-weight: 400;
  margin: 5px 0 10px 3px;
}

.box {
  max-width: 600px;
  border: 2px solid #022245;
  display: flex;
  padding: 15px;
  height: 150px;
  border-radius: 10px;
  gap: 20px;
  overflow-x: scroll;
  scroll-behavior: smooth;
}

.box::-webkit-scrollbar {
  display: none;
}

.box-child {
  border-radius: 10px;
  border: 1px solid #808080;
  padding: 15px;
  min-width: 450px;
  cursor: pointer;
}

.arrow-ball-right {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 110px;
  right: 55px;
  width: 40px;
  height: 40px;
  background-color: #022245;
  border-radius: 50%;
  cursor: pointer;
}

.arrow-ball-left {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 110px;
  right: 600px;
  background-color: #022245;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}

main.menuCollapsed {
  margin-left: 90px;
  transition: all 0.5s ease;
}

main {
  /*background-color: #fafafa;*/
  margin-left: 250px;
  transition: all 0.5s ease;
  padding: 0 10px 0 10px;
  box-sizing: border-box;
  z-index: 1;
}

.btn-feedback {
  background-color: #CBD63E;
  color: #022245;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  line-height: 24px;

  i {
    color: #022245;
    margin-right: 30px;
  }

  img {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }
}

.content_top {
  display: flex;
  align-items: end;
  justify-content: space-between;
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .content_top {
    flex-wrap: wrap;

  }

  .mobile {
    margin-top: 20px;

  }
}

.content {

}

@media (min-width: 870px) {
  .content {
    width: 100%;
  }
}

@media (min-width: 1700px) {
  main {
    padding: 0 10px 0 30px;
  }
}
@media (max-width: 900px) {
  .mobile {
    flex-wrap: wrap;
  }
}
</style>
